import { gql } from '@apollo/client';

import {
  ACTUAL_COOKED_WEIGHT_ENTRY_FIELDS,
  LINKED_COMPONENT_FIELDS,
  CUP_SIZES_FIELDS,
  CUPS_QUANTITY_FIELDS,
  COMPONENT_SHORTAGE_FIELDS,
  CHILD_FIELDS,
  FOOD_COMPONENT_QUALITY_STANDARD_FIELDS,
  USER_FIELDS,
  CURRENT_COOKED_WEIGHT_DATA_FIELDS,
  LOCALIZED_FIELDS,
  COOKING_STATIONS_FIELDS,
  KITCHEN_WASTAGE_INPUTS_FIELDS
} from '../graphQL/fragments';

export const FOOD_COMPONENT_FIELDS = gql`
  ${LOCALIZED_FIELDS}
  ${COOKING_STATIONS_FIELDS}
  ${KITCHEN_WASTAGE_INPUTS_FIELDS}
  ${LINKED_COMPONENT_FIELDS}
  ${CUP_SIZES_FIELDS}
  ${CUPS_QUANTITY_FIELDS}
  ${COMPONENT_SHORTAGE_FIELDS}
  ${CHILD_FIELDS}
  ${FOOD_COMPONENT_QUALITY_STANDARD_FIELDS}
  ${USER_FIELDS}
  ${CURRENT_COOKED_WEIGHT_DATA_FIELDS}
  ${ACTUAL_COOKED_WEIGHT_ENTRY_FIELDS}
  fragment FoodComponentFields on FoodComponent {
    id
    name {
      ...LocalizedFields
    }
    count
    weight
    cookedWeight
    totalCookedWeight
    measurementUnit
    cookingStations {
      ...CookingStationsFields
    }
    date
    country
    kitchen
    kitchenWastageInputs {
      ...KitchenWastageInputsFields
    }
    brand
    childComponents {
      ...LinkedComponentFields
    }
    foodsIds
    cost
    quantities
    quantity
    cups {
      ...CupSizesFields
    }
    cupsQuantity {
      ...CupsQuantityFields
    }
    shortages {
      ...ComponentShortageFields
    }
    purchasingCost
    child {
      ...ChildFields
    }
    standards {
      ...FoodComponentQualityStandardFields
    }
    isVerified
    verifiedBy {
      ...UserFields
    }
    prototype
    cookedRawFactor
    currentCookedWeight {
      ...CurrentCookedWeightDataFields
    }
    actualCookedWeight {
      ...ActualCookedWeightEntryFields
    }
  }
`;

export const LIST_FOOD_COMPONENT_BY_RANGE_RESPONSE_FIELDS = gql`
  ${FOOD_COMPONENT_FIELDS}
  fragment ListFoodComponentByRangeResponseFields on ListFoodComponentByRangeResponse {
    components {
      ...FoodComponentFields
    }
    next
  }
`;
